/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateTalentPool } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TalentPoolDetails } from '@coin/shared/core/util-models-v2';
import { UpdateTalentPool } from '@coin/shared/core/util-models-v2';
import { UpdateTalentPoolAvailability } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateTalentPoolsParams {
  createTalentPool?: CreateTalentPool;
}

export interface DeleteTalentPoolsParams {
  id: string;
}

export interface UpdateAvailabilityTalentPoolsParams {
  updateTalentPoolAvailability?: UpdateTalentPoolAvailability;
}

export interface UpdateTalentPoolsParams {
  id: string;
  updateTalentPool?: UpdateTalentPool;
}

@Injectable({
  providedIn: 'root'
})
export class SuccessionManagementAdminService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTalentPools(
    requestParameters?: CreateTalentPoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentPoolDetails>;
  public createTalentPools(
    requestParameters?: CreateTalentPoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentPoolDetails>>;
  public createTalentPools(
    requestParameters?: CreateTalentPoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentPoolDetails>>;
  public createTalentPools(requestParameters?: CreateTalentPoolsParams, ...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/succession-management/admin/v1/talent-pools`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createTalentPool,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTalentPools(
    requestParameters?: DeleteTalentPoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<StatusResponse>;
  public deleteTalentPools(
    requestParameters?: DeleteTalentPoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<StatusResponse>>;
  public deleteTalentPools(
    requestParameters?: DeleteTalentPoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<StatusResponse>>;
  public deleteTalentPools(requestParameters?: DeleteTalentPoolsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('deleteTalentPools', { id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/succession-management/admin/v1/talent-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAvailabilityTalentPools(
    requestParameters?: UpdateAvailabilityTalentPoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<UpdateTalentPoolAvailability>;
  public updateAvailabilityTalentPools(
    requestParameters?: UpdateAvailabilityTalentPoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<UpdateTalentPoolAvailability>>;
  public updateAvailabilityTalentPools(
    requestParameters?: UpdateAvailabilityTalentPoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<UpdateTalentPoolAvailability>>;
  public updateAvailabilityTalentPools(
    requestParameters?: UpdateAvailabilityTalentPoolsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'put',
      path: `/succession-management/admin/v1/talent-pools/availability`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTalentPoolAvailability,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateTalentPools(
    requestParameters?: UpdateTalentPoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TalentPoolDetails>;
  public updateTalentPools(
    requestParameters?: UpdateTalentPoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TalentPoolDetails>>;
  public updateTalentPools(
    requestParameters?: UpdateTalentPoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TalentPoolDetails>>;
  public updateTalentPools(requestParameters?: UpdateTalentPoolsParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updateTalentPools', { id });
    return this.sendRequest(args, {
      method: 'put',
      path: `/succession-management/admin/v1/talent-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateTalentPool,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
